import { SHIFT_STATUS } from "../constants";
import {
  getFacilityRoleRate,
  normalizeFacilityId,
  normalizeRoleKey,
} from "./facilityProfileEngine";

export function buildShiftPayload({
  facilityProfile,
  facilityId,
  facilityName,
  tenantId,
  tenantName,
  tenantType,
  role,
  status = SHIFT_STATUS.OPEN,
  start,
  end,
  startTime,
  endTime,
  createdBy,
  workerId,
  workerName,
  assignedWorkerId,
  assignedWorkerName,
  assignedWorkerUid,
  assignedWorkerUids = [],
  offeredTo = [],
  requestedBy = [],
  extra = {},
}) {
  const cleanFacilityId =
    normalizeFacilityId(facilityId) ||
    normalizeFacilityId(facilityProfile?.facilityId);

  const cleanTenantId = String(
    tenantId ||
      extra?.tenantId ||
      facilityProfile?.tenantId ||
      "dogebridge"
  )
    .trim()
    .toLowerCase();

  const cleanRole = normalizeRoleKey(role);

  const rates = getFacilityRoleRate(
    facilityProfile,
    cleanRole
  );

  const cleanStart =
    start ||
    startTime ||
    null;

  const cleanEnd =
    end ||
    endTime ||
    null;

  const cleanWorkerId =
    workerId ||
    assignedWorkerId ||
    assignedWorkerUid ||
    assignedWorkerUids?.[0] ||
    "";

  const cleanWorkerName =
    workerName ||
    assignedWorkerName ||
    "";

  const cleanOfferedTo = Array.isArray(offeredTo)
    ? offeredTo.filter(Boolean)
    : [];

  const cleanRequestedBy = Array.isArray(requestedBy)
    ? requestedBy.filter(Boolean)
    : [];

  const cleanAssignedWorkerUids =
    cleanWorkerId
      ? [cleanWorkerId]
      : [];

  const nowIso = new Date().toISOString();

  return {
    ...extra,

    /*
     * Canonical ShiftBridge scope.
     * Explicit Planner values win over facility-profile fallbacks.
     */
    tenantId: cleanTenantId,

    tenantName:
      tenantName ||
      extra?.tenantName ||
      facilityProfile?.tenantName ||
      "DogeBridge Staffing",

    tenantType:
      tenantType ||
      extra?.tenantType ||
      facilityProfile?.tenantType ||
      "staffing_agency",

    facilityId: cleanFacilityId,

    facilityName:
      facilityName ||
      facilityProfile?.name ||
      facilityProfile?.facilityName ||
      "",

    /*
     * Canonical shift identity/lifecycle.
     */
    role: cleanRole,
    requiredPosition: cleanRole,
    status,

    start: cleanStart,
    end: cleanEnd,
    startTime: cleanStart,
    endTime: cleanEnd,

    /*
     * Canonical assignment fields.
     */
    workerId: cleanWorkerId,
    workerName: cleanWorkerName,

    assignedWorkerId: cleanWorkerId,
    assignedWorkerUid: cleanWorkerId,
    assignedWorkerUids:
      cleanAssignedWorkerUids,

    assignedWorkerName:
      cleanWorkerName,

    /*
     * Offer/request compatibility fields.
     */
    offeredTo: cleanOfferedTo,
    requestedBy: cleanRequestedBy,

    /*
     * Rates.
     */
    billRate: Number(
      rates?.billRate || 0
    ),

    compensationRateVersion: facilityProfile?.compensationRateVersion || null,

    /*
     * Audit fields.
     */
    createdBy:
      createdBy || "",

    updatedAt:
      extra?.updatedAt || nowIso,

    createdAt:
      extra?.createdAt || nowIso,
  };
}